import api from "../api"

export class SerasaService {
    static pathBase = "/contracts/score/serasa/"

    static async uploadDocument(document: File) {
        const data = new FormData()
        data.append("file", document)

        return api.put(this.pathBase + "file", data, {
            headers: {
                "Content-Type": "multipart/formdata",
            }
        })
    }

    static async generateQRCode() {
        return api.post(this.pathBase + "paid")
    }

    static async get() {
        return api.get(this.pathBase)
    }

    static async checkStatus(id: number) {
        return api.get("/finance/receipts/" + id)
    }
}